import { useSuspenseQuery } from '@apollo/client';

import { eluveAdminHasuraContext } from '@eluve/apollo-client';

import { findPatientImportJobByIdQuery } from '../patient-import.operations';

/**
 * Look up the tenantId for a job-id route param.
 *
 * Top-level patient-import routes (`/admin/patient-imports/:jobId/*`) don't
 * have tenantId in the URL, but every downstream screen needs it as a prop.
 * This hook fetches the job by id and returns the tenantId, or `null` if
 * the id is missing/unknown so the caller can redirect.
 */
export const useResolveJobTenantId = (
  jobId: string | undefined,
): string | null => {
  const { data } = useSuspenseQuery(findPatientImportJobByIdQuery, {
    variables: { jobId: jobId ?? '' },
    context: eluveAdminHasuraContext,
    skip: !jobId,
  });
  return data?.patientImportJobs?.[0]?.tenantId ?? null;
};
